import type { AccessPolicy } from "@/api/admin-api"

export function isPolicyConfigured(policy: AccessPolicy | undefined): boolean {
  const requires = policy?.requires
  const block = policy?.block
  return (
    !!requires?.oids?.length ||
    !!requires?.groups?.length ||
    !!block?.oids?.length ||
    !!block?.groups?.length ||
    policy?.unrestricted === true
  )
}
